import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function EditServiceRecord() {
  const { id: vehicleId, recordId } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [serviceTypes, setServiceTypes] = useState([]);

  useEffect(() => {
    api(`/service-types`).then(r => r.json()).then(setServiceTypes).catch(() => {});
    api(`/vehicles/${vehicleId}/service-records/${recordId}`).then(r => r.json()).then(r =>
      setForm({ serviceType: r.serviceType || '', serviceDate: r.serviceDate || '', mileage: r.mileage || '', cost: r.cost || '', shop: r.shop || '', technician: r.technician || '', notes: r.notes || '', status: r.status || 'Completed' })
    );
  }, [vehicleId, recordId]);

  if (!form) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { ...form, serviceType: form.serviceType === '__custom' ? form.serviceTypeCustom : form.serviceType, mileage: form.mileage ? parseInt(form.mileage) : null, cost: form.cost ? parseFloat(form.cost) : null };
    const res = await api(`/vehicles/${vehicleId}/service-records/${recordId}`, { method: 'PUT', body: JSON.stringify(body) });
    if (res.ok) navigate(`/vehicles/${vehicleId}`);
  };

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const isKnownType = serviceTypes.some(st => st.name === form.serviceType);
  const selectValue = isKnownType ? form.serviceType : (form.serviceType ? '__custom' : '');

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow max-w-2xl">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900">Edit Service Record</h1>
        </div>
        <form onSubmit={handleSubmit} className="p-4 md:p-6 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Service Type *</label>
              <select name="serviceType" required value={selectValue} onChange={(e) => setForm({ ...form, serviceType: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600">
                <option value="">Select a type...</option>
                {serviceTypes.map(st => <option key={st.id} value={st.name}>{st.name}</option>)}
                <option value="__custom">Other (custom)</option>
              </select>
              {selectValue === '__custom' && (
                <input name="serviceTypeCustom" placeholder="Enter custom type..." required value={form.serviceTypeCustom || (isKnownType ? '' : form.serviceType)} onChange={(e) => setForm({ ...form, serviceTypeCustom: e.target.value })} className="w-full mt-2 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Date *</label>
              <input name="serviceDate" type="date" required value={form.serviceDate} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mileage</label>
              <input name="mileage" type="number" value={form.mileage} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Cost</label>
              <input name="cost" type="number" step="0.01" value={form.cost} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select name="status" value={form.status} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600">
                <option>Completed</option>
                <option>In Progress</option>
                <option>Scheduled</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Shop</label>
              <input name="shop" value={form.shop} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Technician</label>
              <input name="technician" value={form.technician} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
            <textarea name="notes" rows="3" value={form.notes} onChange={onChange} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600" />
          </div>
          <div className="flex gap-3 pt-4">
            <button type="submit" className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">Save</button>
            <button type="button" onClick={() => navigate(`/vehicles/${vehicleId}`)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
          </div>
        </form>
      </div>
    </Layout>
  );
}
